import { SkeletonItem } from 'components/reusable/SkeletonItem'
import { formatMoney } from 'utils'

import { type CostBreakdownItem } from './types'

interface CostBreakdownTableProps {
  items: CostBreakdownItem[]
  isLoading?: boolean
}

function CostBreakdownTableHeader () {
  return (
    <thead className='border-none'>
      <tr className='bg-gray-100 border-none'>
        <th className='text-left py-2 pl-4 body-sm rounded-tl-lg rounded-bl-lg'>Description</th>
        <th className='text-left py-2 body-sm'>Quantity</th>
        <th className='text-left py-2 body-sm rounded-tr-lg rounded-br-lg'>Cost</th>
      </tr>
    </thead>
  )
}

interface CostBreakdownRowProps {
  item: CostBreakdownItem
  isLoading?: boolean
}

function CostBreakdownRow ({ item, isLoading }: CostBreakdownRowProps) {
  return (
    <tr>
      <td className='py-3 px-4'>
        <div className='body'>{item.title}</div>
        <div className='body-sm text-gray-500 mt-1'>
          {item.description}
        </div>
        {item.link && (
          <a href={item.link.href} className='body-sm text-purple-600 mt-1 block underline decoration-dotted'>
            {item.link.text}
          </a>
        )}
        {item.modalTrigger && (
          <div className='mt-1'>
            {item.modalTrigger}
          </div>
        )}
      </td>
      <td className='py-3 px-4'>
        {isLoading
          ? (
            <SkeletonItem heightClass='h-5' widthClass='w-16' />
            )
          : (
            <div className='body'>{item.employeeCount ?? '---'}</div>
            )}
        {!isLoading && item.perUnitAmount !== undefined && (
          <div className='body-sm text-gray-500 mt-1'>
            {formatMoney(item.perUnitAmount)} each
          </div>
        )}
      </td>
      <td className='py-3 px-4 body'>
        {isLoading ? <SkeletonItem heightClass='h-5' widthClass='w-20' /> : item.amount}
      </td>
    </tr>
  )
}

export function CostBreakdownTable ({ items, isLoading }: CostBreakdownTableProps) {
  return (
    <table className='hidden md:table w-full'>
      <CostBreakdownTableHeader />
      <tbody className='p-4'>
        {items.map((item, index) => (
          <CostBreakdownRow key={index} item={item} isLoading={isLoading} />
        ))}
      </tbody>
    </table>
  )
}

export type { CostBreakdownItem }
